import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Only scroll to top on actual route changes, not hash changes
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]); // Only depend on pathname, not hash

  return null;
}